import { render, staticRenderFns } from "./AscensoPage.vue?vue&type=template&id=261cc344"
import script from "./AscensoPage.js?vue&type=script&lang=js&external"
export * from "./AscensoPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports